import React, { Component } from 'react';
import { Modal, Spin, Row, Col, Select, message } from 'antd';
import API_URL from '../../../../common/url';
import $ from '../../../../common/AjaxRequest';

const { Option } = Select;

class RelatedVisit extends Component {
    state = {
        visible: false,
        loading: false,
        groupList: [],
        selectedGroupIds: [],
    }

    record = {}

    show = record => {
        this.record = record;
        // 解析已关联的访视方案ID用于回显
        const initialIds = record.relatedGroupIds
            ? record.relatedGroupIds.split(',').filter(id => id)
            : [];
        this.setState({
            visible: true,
            selectedGroupIds: initialIds,
            groupList: [],
        }, () => {
            this.queryGroupForAddRelated();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    queryGroupForAddRelated = () => {
        const { visitTypeId } = this.record;
        const { visitGroupingId } = this.props;
        const { invId } = sessionStorage;
        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.queryGroupForAddRelated,
            data: {
                visitTypeId,
                currentGroupId: visitGroupingId,
                investigationId: invId,
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    groupList: res.data || [],
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        });
    }

    handleChange = value => {
        this.setState({ selectedGroupIds: value });
    }

    handleSubmit = () => {
        const { visitTypeId } = this.record;
        const { selectedGroupIds } = this.state;
        const { invId } = sessionStorage;

        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.saveRelated,
            data: {
                visitTypeId,
                visitGroupingIds: (selectedGroupIds || []).join(','),
                investigationId: invId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.hide();
                this.setState({ loading: false }, () => {
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        });
    }

    render() {
        const { visitTypeName } = this.record;
        const { visible, loading, groupList, selectedGroupIds } = this.state;

        return (
            <Modal
                title="关联访视次数"
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                confirmLoading={loading}
                maskClosable={false}
                width="500px"
            >
                <Spin spinning={loading}>
                    <div style={{ lineHeight: '40px' }}>
                        <Row>
                            <Col span={6} style={{ textAlign: 'right' }}>访视次数：</Col>
                            <Col span={16} offset={1}>{visitTypeName}</Col>
                        </Row>
                        <Row>
                            <Col span={6} style={{ textAlign: 'right' }}>关联访视方案：</Col>
                            <Col span={16} offset={1}>
                                <Select
                                    mode="multiple"
                                    style={{ width: '100%' }}
                                    placeholder="请选择"
                                    value={selectedGroupIds}
                                    onChange={this.handleChange}
                                    notFoundContent="暂无可以关联的访视方案"
                                >
                                    {groupList.map(i => (
                                        <Option key={i.visitGroupingId} value={String(i.visitGroupingId)}>
                                            {i.visitGroupingName}
                                        </Option>
                                    ))}
                                </Select>
                            </Col>
                        </Row>
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default RelatedVisit;



// WEBPACK FOOTER //
// ./src/components/executeMgr/visitPeriodPlan/components/RelatedVisit.js